

export const getAuthSigMessage = (nonce: string) => {
  return [
    "Sign this message to log into your umi account.\n",
    "This verifies wallet ownership safely and without gas fees, and does not allow umi to perform transactions with your wallet.\n",
    `Nonce: ${nonce}`,
  ].join("\n");
};

export const getEncryptionSigMessage = (version: "v1") => {
  return {
    v1: [
      "Sign this message to generate your personal Umi encryption key.\n",
      "This encryption key is COMPLETELY private—it is NEVER stored on Umi's servers, and only YOU can generate it.\n",
      "The key ensures that your data is encrypted, stored, and managed securely within the Umi platform. If you have any questions or need help, feel free to contact us on Discord or X!"
    ].join("\n"),
  }[version];
};
